import { Component, OnInit, Input } from '@angular/core';
import { SharedService } from 'src/app/core/services/shared.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-panel-listado',
  templateUrl: './panel-listado.component.html',
  styleUrls: ['./panel-listado.component.scss']
})

export class PanelListadoComponent implements OnInit {

  @Input() SYS38COD : string = '';
  @Input() arrFiltros : any;

  Paneles    : any;

  constructor(private dataService: SharedService) { 
  }

  ngOnInit(): void {
  }

  ngOnChanges() {
    this._fetchData();
  }

  private _fetchData(){
    if (this.arrFiltros == undefined) {
      this.arrFiltros = JSON.parse('{"FILTROS_OPCIONALES":[]}');
    }
        
    this.dataService.ConsultarWS('api/charts/ViewIndicador/' + this.SYS38COD, JSON.stringify(this.arrFiltros)).subscribe(
      (datosResp: any) => {
        this.Paneles    = datosResp.DATA;
      },
      error => {
        Swal.fire({
          html: '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
            '<div class="col-4">' +
            ' <img src="assets/images/imageerror.png"> </img>' +
            '</div>' +
            ' <div class="col-8">' +
            '<h3>Error</h3><br>' +
            ' <p>' + error + '</p>' +
            ' </div> ',
        })
      }
    );
  } 
}